module.exports = __webpack_public_path__ + "static/media/reset.8f55d1cb.svg";